import { createContext } from 'react';

export const PrimeInfoContext = createContext({
  userAccountResponse: { data: null, errors: null, loading: false },
  primeSitePropertiesResponse: { data: null, errors: null, loading: false },
});
